import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

export default function JobFilters({
  open,
  setOpen,
  selectedJobStatus,
  jobsCount,
  JOB_STATUS_MAP,
}) {
  // hooks
  const router = useRouter();
  const [selected, setSelected] = useState(selectedJobStatus);

  const statuses = Object.keys(JOB_STATUS_MAP).map(status => {
    const { label, value } = JOB_STATUS_MAP[status];
    const count = jobsCount[status];

    return {
      count,
      label,
      value,
    };
  });

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="Space-between"
        >
          <Typography variant="h3">Filter</Typography>
          <IconButton
            onClick={() => {
              setOpen(false);
            }}
          >
            <Iconify icon="tabler:x" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing="12px">
          <Typography variant="subheading1" fontWeight={600}>
            Job Status
          </Typography>
          <Stack direction="row" spacing="12px" alignItems="center">
            {statuses.map(({ count, label, value }) => (
              <Button
                key={value}
                variant="soft"
                size="small"
                onClick={() => {
                  setSelected(prev => (prev === value ? '' : value));
                }}
                sx={{
                  color: theme => theme.palette.content.primaryBlack1,
                  cursor: 'pointer',
                  borderRadius: 39,
                  background: theme =>
                    theme.palette.background[
                      selected === value ? 'primaryAccent2' : 'primaryGrey2'
                    ],
                  border: theme =>
                    `1px solid ${
                      theme.palette.border[
                        selected === value ? 'primaryAccent1' : 'primaryBlack3'
                      ]
                    }`,
                  height: 30,
                  padding: '4px 10px',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <Typography variant="caption">
                  {`${label} (${count})`}
                </Typography>
              </Button>
            ))}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Stack
            sx={{
              flexDirection: 'row',
              gap: '12px',
              alignItems: 'center',
            }}
          >
            <Button
              variant="contained"
              disabled={!selected}
              onClick={() => {
                if (selected) {
                  router.push(
                    `${paths.dashboard.jobs.root}?status=${selected}`,
                  );
                } else {
                  router.push(`${paths.dashboard.jobs.root}`);
                }

                setOpen(false);
              }}
            >
              View results
            </Button>
          </Stack>
          <Typography
            variant="input"
            sx={{ fontSize: '16px', fontWeight: 500, cursor: 'pointer' }}
            onClick={() => setSelected('')}
          >
            Clear all
          </Typography>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

JobFilters.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  selectedJobStatus: PropTypes.string.isRequired,
  jobsCount: PropTypes.object.isRequired,
  JOB_STATUS_MAP: PropTypes.object.isRequired,
};
